// extracted by mini-css-extract-plugin
module.exports = {"popup-container-class":"search_popup-container-class__K7jMn","popup-content-title":"search_popup-content-title__1NJVd"};